import { Key } from 'react';
import { t } from 'i18next';
import { AiOutlineCheckCircle, AiOutlineFieldTime, AiOutlineFileText, AiOutlineCloseCircle } from 'react-icons/ai';
import { CiCalendarDate } from 'react-icons/ci';
import format from 'date-fns/format';

import { AccountService } from '../../../services/AccountService';
import { downloadFileS3 } from '../../../utils/downloadFile';
import { useApi } from '../../../services/hooks/apiHook';
import { AxiosInstance } from 'axios';

import { DataResponse, StatusOnGoingEnum } from './Types';
import { Header, Section, StatusButton, Title } from './styleGuide';

export const CollapsibleOngoing = ({ dataResponse, headers }: any) => {
  const api: AxiosInstance = useApi();

  const { data } = dataResponse[0];

  const formatterValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });
  const formatterDate = (date: string) => format(new Date(date), 'MM/dd/yyyy');

  const fetchUrlTempDownloadCertificate = async (idDocument: number, serviceTitle: string) => {
    try {
      if (idDocument) {
        const { data } = await AccountService.getDownloadDocuments(api, idDocument, { headers });

        return downloadFileS3(data.temporaryUrl, serviceTitle);
      } else {
        console.log('Error, url download is null', idDocument);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <article className="grid grid-cols-1 gap-4">
        <Header>{t('OnboardingRequestInitPage')}</Header>
        <div>

          {data?.data.map((request: DataResponse, index: Key) => (
            <Section key={index} style={{ height: 'auto' }}>
              <div className="flex flex-row flex-wrap items-center justify-between">
                <div>
                  <Title>{request?.title}</Title>
                  <div className="flex flex-row items-center">
                    <CiCalendarDate className="mr-1 translate-y-[-1px]" size={20} />
                    <p className="mr-1 font-semibold">{formatterDate(request?.created_at)}</p> -{' '}
                    {formatterValue.format(request?.value)}
                  </div>
                </div>
                <div className="flex flex-row items-center">
                  {request?.statusEnum === StatusOnGoingEnum.COMPLETED && (
                    <div className="flex flex-row flex-wrap items-center">
                      <AiOutlineCheckCircle size={18} color="#06C051" />
                      <span className="ml-1 font-semibold capitalize text-[#06C051]">{request.status}</span>
                      {request.companies_document_id && (
                        <StatusButton
                          onClick={() => fetchUrlTempDownloadCertificate(request.companies_document_id, request.title)}
                        >
                          {t('OnboardingDownloadDocument')}
                        </StatusButton>
                      )}
                    </div>
                  )}

                  {request?.statusEnum === StatusOnGoingEnum.PENDING_SIGNATURE_FILE && (
                    <div className="flex flex-row items-center">
                      <AiOutlineFieldTime size={20} color="#010101" />
                      <span className="ml-2 font-semibold capitalize text-[#010101]">{request.status}</span>
                    </div>
                  )}

                  {request?.statusEnum === StatusOnGoingEnum.PENDING_UPLOAD_FILE && (
                    <div className="flex flex-row items-center">
                      <AiOutlineFieldTime size={20} color="#010101" />
                      <span className="ml-2 font-semibold capitalize text-[#010101]">
                        {t('others.othWaitingApproval')}
                      </span>
                    </div>
                  )}

                  {request?.statusEnum === StatusOnGoingEnum.PENDING_PAYMENT && (
                    <StatusButton
                      onClick={() => {
                        window.open(`${request?.payment_url}`, '_blank');
                      }}
                    >
                      {t('OnboardingRequestCompleteRequest')}
                    </StatusButton>
                  )}

                  {request?.statusEnum === StatusOnGoingEnum.CANCELED && (
                    <div className="flex flex-row items-center">
                      <AiOutlineCloseCircle size={20} color="#FF0000" />
                      <span className="ml-2 font-semibold capitalize text-[#FF0000]">{request.status}</span>
                    </div>
                  )}
                </div>
              </div>
            </Section>
          ))}

          {data.length === 0 && (
            <div>
              <AiOutlineFileText />
              <h1> {t('OnboardingRequestNoData')}</h1>
            </div>
          )}
        </div>
      </article>
    </>
  );
};
